import AlertModal from 'components/Modal/AlertModal';
import ConfirmModal from 'components/Modal/ConfirmModal';
import DsShowcaseModal from 'components/Modal/DsShowcaseModal';
import PromptModal from 'components/Modal/PromptModal';
import SettingsModal from 'components/Modal/SettingsModal';
import PlanPricingModal from 'components/Modal/PlanPricingModal';
import { shallowEqual, useSelector } from 'react-redux';
import { RootReducer, selectIsLoadingAnything } from 'redux/reducers';

const ModalManager = () => {
	const {
		globalPromptModalOptions,
		globalConfirmModalOptions,
		globalAlertModalOptions,
		planPricingModalVisible,
		dsShowcaseModal,
		settingsModalVisible,
	} = useSelector((r: RootReducer) => {
		return {
			loading: selectIsLoadingAnything(r),
			sceneLoadError: r.db.sceneLoadError,
			globalPromptModalOptions: r.mode.promptModal,
			globalConfirmModalOptions: r.mode.confirmModal,
			globalAlertModalOptions: r.mode.alertModal,
			planPricingModalVisible: r.mode.planPricingModalVisible,
			dsShowcaseModal: r.mode.dsShowcaseModal,
			settingsModalVisible: r.mode.settingsModalVisible,
		};
	}, shallowEqual);

	return (
		<>
			{globalPromptModalOptions && <PromptModal options={globalPromptModalOptions} />}
			{globalConfirmModalOptions && <ConfirmModal options={globalConfirmModalOptions} />}
			{globalAlertModalOptions && <AlertModal options={globalAlertModalOptions} />}
			{planPricingModalVisible && <PlanPricingModal />}
			{dsShowcaseModal && <DsShowcaseModal />}
			{settingsModalVisible && <SettingsModal />}
		</>
	);
};

export default ModalManager;
